import { render, staticRenderFns } from "./InsertResults.vue?vue&type=template&id=632f810a&"
import script from "./InsertResults.vue?vue&type=script&lang=js&"
export * from "./InsertResults.vue?vue&type=script&lang=js&"
import style0 from "./InsertResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports